<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl p-8 max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold text-gray-800">
          {{ code ? 'Zugangscode bearbeiten' : 'Zugangscode hinzufügen' }}
        </h2>
        <button @click="$emit('close')" class="text-gray-700 hover:text-black text-3xl admin-button--ghost admin-button--icon" aria-label="Schließen" title="Schließen">
          <i class="fa fa-xmark"></i>
        </button>
      </div>

      <div class="space-y-4">
        <div>
          <label class="block text-sm font-semibold mb-2">Code: *</label>
          <input 
            v-model="localCode.code" 
            class="border rounded px-3 py-2 w-full font-mono"
            placeholder="z.B. 1234 oder #5678*"
          />
        </div>

        <div>
          <label class="block text-sm font-semibold mb-2">Beschreibung:</label>
          <input 
            v-model="localCode.description" 
            class="border rounded px-3 py-2 w-full"
            placeholder="z.B. Haupteingang, Notausgang"
          />
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-semibold mb-2">Gültig von:</label>
            <input 
              type="date" 
              v-model="localCode.validFrom" 
              class="border rounded px-3 py-2 w-full"
            />
          </div>
          <div>
            <label class="block text-sm font-semibold mb-2">Gültig bis:</label>
            <input 
              type="date" 
              v-model="localCode.validUntil" 
              class="border rounded px-3 py-2 w-full"
            />
          </div>
        </div>

        <div>
          <label class="flex items-center cursor-pointer">
            <input 
              type="checkbox" 
              v-model="localCode.active" 
              class="mr-2"
            />
            <span class="font-semibold">Code ist aktiv</span>
          </label>
        </div>

        <div class="p-4 bg-blue-50 border border-blue-200 rounded">
          <h3 class="font-semibold mb-2">Zuordnung:</h3>
          <div class="text-sm text-gray-700">
            <p v-if="localCode.contractName"><strong>Vertrag:</strong> {{ localCode.contractName }}</p>
            <p v-if="localCode.locationName"><strong>Einsatzort:</strong> {{ localCode.locationName }}</p>
            <p v-if="localCode.placeName"><strong>Einsatzstelle:</strong> {{ localCode.placeName }}</p>
          </div>
        </div>

        <div v-if="errorMessage" class="p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {{ errorMessage }}
        </div>
      </div>

      <div class="flex justify-end gap-3 mt-6">
        <button 
          @click="$emit('close')" 
          class="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 font-semibold admin-button--secondary">
          Abbrechen
        </button>
        <button 
          @click="save" 
          class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-semibold admin-button--primary">
          <i class="fa fa-check mr-2"></i>Speichern
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CASP from "../CASP";

export default {
  name: 'AccessCodeModal',
  props: {
    code: {
      type: Object,
      default: null
    },
    defaultContext: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close', 'save'],
  data() {
    return {
      localCode: {
        code: '',
        description: '',
        contractId: null,
        contractName: '',
        locationId: null,
        locationName: '',
        placeId: null,
        placeName: '',
        active: true,
        validFrom: null,
        validUntil: null
      },
      errorMessage: ''
    };
  },
  methods: {
    save() {
      if (!this.localCode.code) {
        this.errorMessage = 'Bitte Code eingeben';
        return;
      }

      document.getElementById("mainspinner").style.display = "inline-block";

      if (this.code) {
        CASP.updateAccessCode(this.code.id, this.localCode, (status, response) => {
          document.getElementById("mainspinner").style.display = "none";
          if (status === 200) {
            this.$emit('save', response);
            this.$emit('close');
          } else {
            this.errorMessage = 'Fehler beim Aktualisieren des Zugangscodes';
          }
        });
      } else {
        CASP.createAccessCode(this.localCode, (status, response) => {
          document.getElementById("mainspinner").style.display = "none";
          if (status === 200 || status === 201) {
            this.$emit('save', response);
            this.$emit('close');
          } else {
            this.errorMessage = 'Fehler beim Erstellen des Zugangscodes';
          }
        });
      }
    }
  },
  mounted() {
    if (this.code) {
      this.localCode = { ...this.code };
      if (this.localCode.validFrom) {
        this.localCode.validFrom = new Date(this.localCode.validFrom).toISOString().split('T')[0];
      }
      if (this.localCode.validUntil) {
        this.localCode.validUntil = new Date(this.localCode.validUntil).toISOString().split('T')[0];
      }
    } else if (this.defaultContext) {
      this.localCode = {
        ...this.localCode,
        ...this.defaultContext
      };
    }
  }
};
</script>

<style scoped>
</style>
